import { SettingsPhoneOutlined } from '@mui/icons-material';
import { Typography, Tooltip, CSSObject } from '@mui/material';

export type Props = {
    isActive: boolean;
    onClick: () => void;
};

const labelStyles: CSSObject = {
    color: '#ffffff',
    fontSize: '1rem',
    position: 'relative',
    top: '-0.094rem',
};

const ButtonVoicePreview = ({ onClick, isActive }: Props) => {
    const iconStyles = {
        color: isActive ? 'secondary.main' : 'primary.main',
        '&:hover': {
            color: 'secondary.main',
            cursor: 'pointer',
        },
    };

    return (
        <Tooltip
            title={
                <Typography variant="body1" sx={labelStyles}>
                    {'Preview content'}
                </Typography>
            }
            placement="top"
        >
            <SettingsPhoneOutlined aria-label="preview content" sx={iconStyles} onClick={onClick} />
        </Tooltip>
    );
};

export default ButtonVoicePreview;
